export const MANUAL_RETAKER = 'heatmap.continuous.manual_retaker';

export const MANUAL_RETAKER_ONLINE = 'heatmap.continuous.manual_retaker_online';

export const SMART_PANEL = 'heatmap.smart_panel';

export const SMART_PANEL_LAYERS_SECTION = 'heatmap.smart_panel.layers_section';
